import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useEnduserStore } from "../../../store/hooks";

export const useStripeBillingPortalButton = () => {
  const { t } = useTranslation("payments");
  const session = useEnduserStore((state) => state.session);
  const currentEnduser = useEnduserStore((state) => state.currentEnduser);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const isVisible = !!currentEnduser?.stripeCustomerId;

  const handleClick = useCallback(async () => {
    if (!session || !currentEnduser?.stripeCustomerId) return;

    setIsLoading(true);
    setError(null);

    try {
      const returnUrl = window.location.href;
      const args: { return_url: string; stripeCustomerId?: string; stripeKey?: string } = {
        return_url: returnUrl,
      };

      if (currentEnduser.stripeKey) {
        args.stripeCustomerId = currentEnduser.stripeCustomerId;
        args.stripeKey = currentEnduser.stripeKey;
      }

      const { url } = await session.api.products.get_stripe_portal_session(args);
      window.location.href = url;
    } catch {
      setError(t("Failed to load. Please try again."));
    } finally {
      setIsLoading(false);
    }
  }, [session, currentEnduser, t]);

  return { isVisible, isLoading, error, handleClick };
};
